import request from './request'

export const myList = (params) => {
    return request({
        url: '/mf/user/myList',
        method: 'get',
        params
    })
}

export const userList = (params) => {
    return request({
        url: '/mf/user/list',
        method: 'get',
        params
    })
}

// 邀请信息查询( 文本类型 )
export const letMingleList = (params) => {
    return request({
        url: '/mf/letMingle/list',
        method: 'get',
        params
    })
}

// 发起邀请
export const letMingleSend = (data) => {
    return request({
        url: '/mf/letMingle/send',
        method: 'post',
        data
    })
}

// 停止邀请
export const letMingleStopeSend = (data) => {
    return request({
        url: '/mf/letMingle/stopeSend',
        method: 'post',
        data
    })
}

// 新增邀请语
export const addLetMingle = (data) => {
    return request({
        url: '/mf/letMingle',
        method: 'post',
        data
    })
}

// 修改
export const editLetMingle = (data) => {
    return request({
        url: '/mf/letMingle',
        method: 'put',
        data
    })
}

// 删除
export const letMingleRecIds = (recIds) => {
    return request({
        url: `/mf/letMingle/${recIds}`,
        method: 'delete',
    })
}

// 邮件类型邀请列表
export const introductoryEmailList = (params) => {
    return request({
        url: '/system/introductoryEmail/list',
        method: 'get',
        params
    })
}

// 邮件模版提交审核
export const introductoryEmailSubmit = (data) => {
    return request({
        url: '/system/introductoryEmail/submit',
        method: 'post',
        data
    })
}

// 邮件模版修改
export const introductoryEmail = (data) => {
    return request({
        url: '/system/introductoryEmail',
        method: 'put',
        headers:{
            isEncrypt: false
        },
        data
    })
}

// 邮件模版删除
export const introductoryEmailRecIds = (recIds) => {
    return request({
        url: `/system/introductoryEmail/${recIds}`,
        method: 'delete',
    })
}
// 邮件模版新增
export const addIntroductoryEmail = (data) => {
    return request({
        url: '/system/introductoryEmail',
        method: 'post',
        headers:{
            isEncrypt: false
        },
        data
    })
}
// 获取邮件模版详情
export const introductoryEmailRecId = (recId) => {
    return request({
        url: `/system/introductoryEmail/${recId}`,
        method: 'get',
    })
}

// 获取邮件表情
export const emailSmilesList = (params) => {
    return request({
        url: '/system/introductoryEmail/smiles',
        method: 'get',
        params
    })
}